module.exports = __webpack_public_path__ + "img/advantage4.d30b6752.png";